import React, { useState } from 'react';

import useNavPath from '../../../hooks/useNavPath';

import './ConfigurationSubmitResponse.css';

import successImg from '../../../images/quotations/icon-success.png';
import failImg from '../../../images/quotations/icon-fail.png';

/**
 * @prop {Object} sendDataResponse
 * @prop {Function} sendDataResponseReset
 */
const ConfigurationSubmitResponse = (props) => {

    const [navPath, setNavPath, navigateToNavPath] = useNavPath();

    const onClickHome = (evt) => {
        setNavPath('/');
    };

    const iconImg = (props.sendDataResponse.result === 'fail') ? failImg : successImg;

    if (navPath !== null) {
        return navigateToNavPath();
    } else {
        return (
            <div className="slc-configurationSubmit-form-response">
                <img className="slc-configurationSubmit-form-response__icon" src={ iconImg } alt="response" />
                <div className="slc-configurationSubmit-form-response__text" dangerouslySetInnerHTML={ { __html: props.sendDataResponse.message } } />
                <div className="slc-configurationSubmit-form-response__buttons">
                    { props.sendDataResponse.result === 'fail'
                        ? <button className="slc-button slc-button-configurationSubmit-response slc-button-gradient btn btn-next btn-primary btn-lg" onClick={ props.sendDataResponseReset }>Riprova</button>
                        : <button className="slc-button slc-button-configurationSubmit-response slc-button-gradient btn btn-next btn-primary btn-lg" onClick={ props.sendDataResponseReset }>Richiedi nuovo preventivo</button>
                    }
                </div>
            </div>
        );
    }

}

export default ConfigurationSubmitResponse;